import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ContinueShopping.css'; // Import your CSS for styling

const ContinueShopping = () => {
    const navigate = useNavigate();

    const handleContinueShopping = () => {
        navigate('/products'); // Adjust the path to your products page
    };

    return (
        <div className="continue-shopping">
            <button onClick={handleContinueShopping} className="continue-button">
                Continue Shopping
            </button>
        </div>
    );
};

export default ContinueShopping;
